import '../vendor';

import '../general/ofi';
import '../general/tooltip';

import './one-exponat/modal-exponat';
import './game-result/game-slider-result';


// WEBPACK FOOTER //
// ./src/js/pages/game-result.js